import { AppAction } from 'actions/ActionTypes'
import { API_CALL } from 'actions/actionConstants'
import requestCalculateBusinessCredits from 'businessTraveller/api/requestGetCalculatedBusinessBudget'
import { BUSINESS_TRAVELLER_ACTIONS } from 'reducers/businessTravellerActionReducer'
import { BUSINESS_TRAVELLER_API_ACTIONS } from 'reducers/businessTravellerApiActionReducers'

function fetchBusinessBudget(
  businessId: string,
  toBeCalculatedBusinessBudget: [budgetKey: string, businessBudget: App.BusinessTraveller.ToBeCalculatedBusinessBudget],
  refetch?: boolean,
): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const [budgetKey, businessBudget] = toBeCalculatedBusinessBudget
    const currentBusinessBudget = state.businessTraveller.businessBudgets[budgetKey]

    if (!currentBusinessBudget || refetch) {
      dispatch({
        type: API_CALL,
        api: BUSINESS_TRAVELLER_API_ACTIONS.FETCH_BUSINESS_BUDGET,
        budgetKey,
        request: () => requestCalculateBusinessCredits({
          businessId,
          toBeCalculatedBusinessBudget: businessBudget,
        }),
      })
    } else if (currentBusinessBudget.status === 'success') {
      dispatch({
        type: BUSINESS_TRAVELLER_ACTIONS.SET_BUSINESS_MAP_BUDGET,
        // 0th index access looks bad, but is acceptable here
        // as placeIds can only have one budget at the moment.
        // There is no logic we can implement to 'find' the correct budget,
        // as that would be an implementation detail of future business needs,
        // such as different budgets for managers and employees (probably done in BE).
        businessMapBudget: currentBusinessBudget.budgets[0],
      })
    }
  }
}

export default fetchBusinessBudget
